/**
 * Moves the prepaid-discount element into price-item--regular element 
 * which comes under price__sale and removes the original
 * Functional programming approach
 */
(function() {
  'use strict';

  // Pure functions for element selection
  const querySelector = (selector, context = document) => context.querySelector(selector);
  const querySelectorAll = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const closest = (element, selector) => element?.closest(selector);

  // Functional helpers
  const pipe = (...fns) => (value) => fns.reduce((acc, fn) => fn(acc), value);
  const filter = (predicate) => (arr) => arr.filter(predicate);
  const map = (fn) => (arr) => arr.map(fn);
  const forEach = (fn) => (arr) => arr.forEach(fn);

  // Predicate functions
  const hasElement = (element) => element !== null && element !== undefined;
  const hasNoPrepaid = (element) => !querySelector('.prepaid-price, .prepaid-discount', element);
  const isValidPriceItem = (element) => hasElement(element) && hasNoPrepaid(element);
  const isNotInsidePriceItemRegular = (element) => {
    const priceItemRegular = closest(element, '.price-item--regular');
    return !priceItemRegular;
  };
  const isCollectionCardPrepaid = (element) =>
    closest(element, '.price-add-cart-container') !== null ||
    element?.dataset?.collectionPrepaid === 'true';
  // Element finder functions
  const findPriceItemRegular = (priceSale) => {
    const wrapperSpan = querySelector(':scope > span.price-item--regular', priceSale);
    if (wrapperSpan && wrapperSpan.tagName === 'SPAN' && !wrapperSpan.classList.contains('price-item')) {
      return wrapperSpan;
    }
    return null;
  };
  const findPrepaidDiscount = (priceSale) => {
    const priceAddCart = closest(priceSale, '.price-add-cart-container');
    const priceContainer = closest(priceSale, '.price');
    const scope = priceAddCart || priceContainer;
    if (!scope) return null;

    const candidates = querySelectorAll('.prepaid-price', scope);
    return candidates.find(
      (prepaid) => isNotInsidePriceItemRegular(prepaid) && !isCollectionCardPrepaid(prepaid)
    ) || null;
  };

  // DOM manipulation functions
  const moveElement = (parent) => (element) => {
    if (parent && element && element.parentNode) {
      parent.appendChild(element);
      return element;
    }
    return null;
  };
  const removeElement = (element) => {
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  };

  // Main processing function
  const processPriceSale = (priceSale) => {
    const prepaidDiscount = findPrepaidDiscount(priceSale);
    if (!prepaidDiscount) return;

    const priceItemRegular = findPriceItemRegular(priceSale);
    if (priceItemRegular && isValidPriceItem(priceItemRegular)) {
      moveElement(priceItemRegular)(prepaidDiscount);
      return;
    }

    moveElement(priceSale)(prepaidDiscount);
  };

  // Main function
  const appendPrepaidDiscount = () => {
    pipe(
      () => querySelectorAll('.price__sale'),
      forEach(processPriceSale)
    )();
  };

  // DOM ready handler
  const whenReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  };

  // Initialize
  whenReady(appendPrepaidDiscount);

  // Export for manual calls
  window.appendPrepaidDiscount = appendPrepaidDiscount;

})();
